import EventEmitter from "../EventEmitter";
import localstore from 'store';

export default class FCM {

	constructor() {
	}

	getToken() {
		return localstore.get('fcm-token');
	}
}


// WEBPACK FOOTER //
// ./src/helpers/FirebaseCloudMessaging.js